import Link from "next/link";
import MarketScheduleEventCard from "./event-card";
const {
  formatClockTime,
  isEventToday,
} = require("../../lib/market-schedule");

function trackHomepageScheduleClick(label) {
  if (typeof window === "undefined") {
    return;
  }

  import("posthog-js")
    .then((module) => {
      const posthog = module.default || module;

      if (posthog && typeof posthog.capture === "function") {
        posthog.capture("market_schedule_homepage_cta_click", { label });
      }
    })
    .catch(() => {});
}

function getTodayCallout(events) {
  return (Array.isArray(events) ? events : []).find((event) => isEventToday(event));
}

function getTodayMessage(event) {
  if (!event) {
    return null;
  }

  const place = event.locationName || event.title;
  const closeTime = formatClockTime(event.closeTime);

  if (closeTime) {
    return `Find us today at ${place} until ${closeTime}.`;
  }

  return `Find us today at ${place}.`;
}

export default function MarketSchedulePreview({ events }) {
  const scheduleEvents = Array.isArray(events) ? events.slice(0, 4) : [];
  const todayEvent = getTodayCallout(scheduleEvents);
  const todayMessage = getTodayMessage(todayEvent);

  return (
    <section className="border-y border-chocolate/15 bg-white/45 px-4 py-10 sm:px-6 lg:px-8">
      <div className="flex flex-col gap-5 md:flex-row md:items-end md:justify-between">
        <div className="max-w-2xl">
          <p className="text-sm font-bold uppercase tracking-[0.18em] text-crimson">Find us this week</p>
          <h2 className="mt-2 font-[Staatliches] text-4xl leading-none tracking-wide text-chocolate">
            Markets and pop-ups
          </h2>
          <p className="mt-3 text-sm font-semibold leading-6 text-chocolate/75">
            {todayMessage || "See where Browned & Toasted is popping up next."}
          </p>
        </div>
        <Link
          className="inline-flex min-h-11 items-center justify-center rounded-lg bg-crimson px-5 py-3 text-sm font-bold text-white transition hover:brightness-105 focus:outline-none focus-visible:ring-2 focus-visible:ring-crimson/40 focus-visible:ring-offset-2"
          href="/find-us"
          onClick={() => trackHomepageScheduleClick("view_full_schedule")}
        >
          View full schedule
        </Link>
      </div>

      {scheduleEvents.length ? (
        <div className="mt-6 grid gap-4 lg:grid-cols-2">
          {scheduleEvents.map((event) => (
            <MarketScheduleEventCard
              compact
              event={event}
              key={`home-${event.eventId}-${event.eventDayId}`}
            />
          ))}
        </div>
      ) : null}
    </section>
  );
}

export { getTodayMessage };
